const memoryCache = () => {
  const cache = {};
  return (key, resolver) => {
    if (!(key in cache)) {
      cache[key] = resolver();
    }
    return cache[key];
  };
};

export default memoryCache;



// WEBPACK FOOTER //
// ./src/assets/js/utils/cache.js